// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapperClassName {
    border: 1px solid #F1F1F1;
    padding: 4px;
    border-radius: 2px;
  }
  
  .editorClassName {
    height: 100%; /* Adjust this value to your desired height */
    padding: 10px;
    border: 1px solid #F1F1F1;
    border-radius: 2px;
    overflow-y: auto;
  }
  
  .toolbarClassName {
    border: 0px solid #F1F1F1;
    border-bottom: none;
    border-radius: 2px 2px 0 0;
    padding: 2px;
    margin: 0;
  }
  
  .rdw-suggestion-dropdown{
    min-width: 220px !important;
    -webkit-box-shadow: 0px 0px 2px 1px rgba(0,0,0,0.75);
    -moz-box-shadow: 0px 0px 2px 1px rgba(0,0,0,0.75);
    box-shadow: 0px 0px 2px 1px rgba(0,0,0,0.75);
  }
  .toolbarClassName div{
    border:0 solid #F1F1F1 !important;
    margin:0 !important;
  }
  .rdw-suggestion-option:hover{
    background: #e6e6e6;
  }
  .rdw-inline-dropdown{
    width: auto;
  }`, "",{"version":3,"sources":["webpack://./src/components/NotyfileAnteckningInputJ/TextEditor/style.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,YAAY,EAAE,6CAA6C;IAC3D,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,0BAA0B;IAC1B,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,2BAA2B;IAC3B,oDAAoD;IACpD,iDAAiD;IACjD,4CAA4C;EAC9C;EACA;IACE,iCAAiC;IACjC,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;EACb","sourcesContent":[".wrapperClassName {\n    border: 1px solid #F1F1F1;\n    padding: 4px;\n    border-radius: 2px;\n  }\n  \n  .editorClassName {\n    height: 100%; /* Adjust this value to your desired height */\n    padding: 10px;\n    border: 1px solid #F1F1F1;\n    border-radius: 2px;\n    overflow-y: auto;\n  }\n  \n  .toolbarClassName {\n    border: 0px solid #F1F1F1;\n    border-bottom: none;\n    border-radius: 2px 2px 0 0;\n    padding: 2px;\n    margin: 0;\n  }\n  \n  .rdw-suggestion-dropdown{\n    min-width: 220px !important;\n    -webkit-box-shadow: 0px 0px 2px 1px rgba(0,0,0,0.75);\n    -moz-box-shadow: 0px 0px 2px 1px rgba(0,0,0,0.75);\n    box-shadow: 0px 0px 2px 1px rgba(0,0,0,0.75);\n  }\n  .toolbarClassName div{\n    border:0 solid #F1F1F1 !important;\n    margin:0 !important;\n  }\n  .rdw-suggestion-option:hover{\n    background: #e6e6e6;\n  }\n  .rdw-inline-dropdown{\n    width: auto;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
